// extracted by mini-css-extract-plugin
module.exports = {"heroItem":"_64d88809","imageWrapper":"_dab51978","image":"_9ca8264b","title":"_797a362c"};